<template>
  <v-list-item two-line :dense="dense">
    <v-list-item-content>
      <v-list-item-title>{{ label }}</v-list-item-title>
      <v-list-item-subtitle>
        {{ value }}
        <slot></slot>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  props: ["label", "value", "dense"],
});
</script>
<style lang="sass" scoped>
.v-list-item__content
  padding: 0
.v-list-item--two-line
  min-height: 1em
  padding: 0 0 10px
  clear: left
.v-list-item--two-line .v-list-item__title
  flex: none
  padding-right: 5px
  min-width: 30px
.v-list-item--two-line .v-list-item__subtitle
  flex: none
  max-width: 100%
  white-space: normal
.mobile-app .v-list-item--two-line .v-list-item__title
  font-size: 3.5vw !important
  margin-bottom: 0 !important
.mobile-app .v-list-item--two-line .v-list-item__subtitle
  font-size: 3.5vw !important
.mobile-app .v-list-item__content
  display: inline-flex
  flex-wrap: nowrap

@media (min-width: 400px)
  .mobile-app .v-list-item--two-line .v-list-item__title
    font-size: 14px !important
  .mobile-app .v-list-item--two-line .v-list-item__subtitle
    font-size: 14px !important
</style>